module.exports = __webpack_public_path__ + "static/media/WonderWoman.6ee63a3d.jpg";